import '../js/open-source/exif-parser.js';
/* global self Blob */
export function GetExifThumbnail(file) {
  return new Promise((resolve, reject) => {
    if (file.type === 'image/jpeg') {
      let reader = new self.FileReader();
      reader.onload = function (e) {
        let blob = null;
        try {
          let parser = self.exifParser.create(reader.result);
          let result = parser.parse();
          if (result.hasThumbnail('image/jpeg')) {
            let buffer = result.getThumbnailBuffer();
            blob = new Blob([buffer], { type: file.type });
          }
        } catch (e) {
          console.warn(`error getting thumbnail: `, e);
        }
        if (!blob) console.warn(`Thumbnail could not be loaded for ${file.name}.  Using full resolution image.`);
        let objectUrl = URL.createObjectURL(blob || file);
        resolve(objectUrl);
      };
      reader.readAsArrayBuffer(file.slice(0, 60000));
    } else reject(new Error('File type must be JPEG'));
  });
}
